/* learn-more click event fix, this code below does not work in inner pages while it worked well in home under custom_home_v2.js*/  
  //console.log('LEARN SCRIPT REGISTERED');

  document.addEventListener('click', function (event) {
    //console.log('DOCUMENT CLICK:', event.target);

    const trigger = event.target.closest('.header__icon-learnmore');

    if (!trigger) return;

    //console.log('LEARN CLICK CAUGHT');

    const menu = document.querySelector('.menu-learn-more');

    if (!menu) return;

    menu.hidden = !menu.hidden;
  });

  /* mobile video close button */
(function () {
  const closeSelector =
  '.fancybox__content > .f-button.is-close-btn';

  const fancyboxLayersSelector = [
    '.fancybox__container',
    '.fancybox__backdrop',
    '.fancybox__viewport',
    '.fancybox__track',
    '.fancybox__slide'
  ].join(', ');

  let isClosing = false;

  function forceHideFancybox() {
    document.querySelectorAll(fancyboxLayersSelector).forEach((element) => {
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });

    document.documentElement.classList.remove('with-fancybox');
    document.body.classList.remove('with-fancybox');
  }

  function isFancyboxStillVisible() {
    return Array.from(
      document.querySelectorAll(fancyboxLayersSelector)
    ).some((element) => {
      const style = window.getComputedStyle(element);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.pointerEvents !== 'none'
      );
    });
  }

  function handleFancyboxClose(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const closeButton = target.closest(closeSelector);

    if (!closeButton || isClosing) return;

    isClosing = true;

    console.log('Fancybox close caught');

    // Trigger Fancybox's own close method first
    try {
      const instance = window.Fancybox?.getInstance?.();

      if (instance) {
        instance.close();
      } else {
        // If no instance is found, trigger the original button click
        // without causing this handler to run again
        closeButton.click();
      }
    } catch (error) {
      console.warn('Fancybox native close failed:', error);
    }

    // First backup check
    setTimeout(() => {
      if (isFancyboxStillVisible()) {
        console.log('Fancybox still active — forcing layers hidden');
        forceHideFancybox();
      }
    }, 300);

    // Final backup for delayed mobile/native video cleanup
    setTimeout(() => {
      if (isFancyboxStillVisible()) {
        forceHideFancybox();
      }

      isClosing = false;
    }, 800);
  }

  // Capture the interaction as early as possible on mobile
  document.addEventListener('pointerdown', handleFancyboxClose, true);
  document.addEventListener('touchend', handleFancyboxClose, true);
  document.addEventListener('click', handleFancyboxClose, true);
})();